import angular from 'angular';
import '../services/sla';
import '../services/errors';
import './modals/sla';

const module = angular.module('whyline.controllers.sla', [
  'whyline.modals.sla',
  'whyline.services.sla',
  'whyline.services.errors',
]);

const SlaController = (
  $scope,
  $uibModal,
  $state,
  $translate,
  SlaService,
  NotificationService,
  ErrorService,
  dialog,
) => {
  /* @ngInject */

  $scope.organizationId = $state.params.organizationId;

  // View init
  SlaService.GetAllAsPromiseFromServer().then((data) => {
    $scope.slas = data;
  });

  $scope.quantityOfItems = 8;

  // Modal
  $scope.open = (slaId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/slas-modal.html',
      size: 'lg',
      controller: 'SlaModalController',
      resolve: {
        slaId: () => slaId,
      },
    });
  };

  $scope.switch = (sla) => {
    const enabled = !sla.enabled;
    const confirmMessage = enabled ? 'sla_enable_sure' : 'sla_disable_sure';
    dialog
      .confirm(confirmMessage)
      .then(() => {
        SlaService.Switch(sla)
          .then(() => {
            NotificationService.Success($translate.instant('sla_update_succ'));
          })
          .catch((error) => {
            sla.enabled = !enabled;
            ErrorService.handler(error);
          });
      })
      .catch((error) => {
        sla.enabled = !enabled;
        ErrorService.handler(error);
      });
  };
};

module.exports = module.controller('SlaController', SlaController);
